import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
    selector: 'app-properjsondialog',
    templateUrl: './properjsondialog.component.html',
    styleUrls: ['./properjsondialog.component.css']
})
export class ProperJsonDialogComponent {
    public jsonData;
    constructor(
        public dialogRef: MatDialogRef<ProperJsonDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,

    ) {
        if (data && data.jsonData) {
            let parseData = data.jsonData;
            let eventType = data.eventType ? { EventType: data.eventType } : null;
            this.jsonData = eventType ? { ...eventType, ...parseData } : { ...parseData };
          }
    }

    onNoClick(): void {
        this.dialogRef.close();
    }


}


// WEBPACK FOOTER //
// ./src/app/properJsonDialog/properjsondialog.component.ts